/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable react/no-array-index-key */

/* eslint-disable no-unused-expressions */

/* eslint-disable react/jsx-key,class-methods-use-this  */

import Checkbox from '@material-ui/core/Checkbox'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Grid from '@material-ui/core/Grid'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { withStyles } from '@material-ui/core/styles'
/**
 *
 * VenueFilters
 *
 */
import classNames from 'classnames/bind'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import shallowEqual from '../../utils/shallowEqual'
import PrimaryButton from '../Button/PrimaryButton'
import Icon from '../Icon'
import filterData from './fixtures/fixture.json'
import messages from './messages'

const styles = theme => ({
  root: {
    display: 'inline-block',
    flexWrap: 'wrap',
    width: '100%',
    float: 'left',
  },
  formControl: {
    border: '1px solid #ccc',
    width: '100%',
    borderRadius: '5px',
    backgroundColor: theme.colors.white,
  },
  selectEmpty: {
    marginTop: theme.spacing(8),
  },
  stgSelect: {
    background: 'transparent',
    '&:before': {
      borderBottom: 'none !important',
    },
    '&:after': {
      background: 'none',
      borderBottom: 'none !important',
    },
    '&:focus': {
      background: 'none',
      borderBottom: 'none !important',
    },
    '&:hover': {
      borderBottom: 'none',
    },
    '& input': {
      padding: '0px',
    },
    '& .MuiSelect-selectMenu* ': {
      width: '90%',
    },
    '& div>div': {
      width: '92%',
      padding: '10px',
    },
  },
  memberInnerContainer: {
    border: '1px solid #ccc',
    position: 'absolute',
    top: 40,
    left: 0,
    width: '425px',
    background: '#F3F3F3',
    padding: '0',
    zIndex: '2',
    overflowY: 'auto',
    // height: '500px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  venueContainer: {
    height: '125px',
    overflow: 'auto',
  },
  panel: {
    '&:before': {
      display: 'none',
    },
  },
  panelSummary: {
    minHeight: 'auto !important',
    '&>div': {
      margin: '0 !important',
    },
  },
  venueLabel: {
    margin: 0,
  },
  playingSurfaceContainer: {
    padding: '0 30px 10px',
  },
  psLabel: {},
  psCheckbox: {
    height: '30px',
  },
  textAlignRight: {
    textAlign: 'right',
    color: theme.palette.secondary.main,
    cursor: 'pointer',
  },
  selectAll: {
    padding: '0 20px 0 0',
  },
  topContainer: {
    padding: '20px 0',
  },
  countDiv: {
    marginRight: '10px',
    background: 'green',
    borderRadius: '36%',
    padding: '3px',
    color: 'white',
  },
  topHeading: {
    padding: '20px',
    borderBottom: '1px solid #ccc',
  },
  bottomFooter: {
    padding: '20px',
    borderTop: '1px solid #ccc',
    textAlign: 'right',
  },
  crossIcon: {
    float: 'right',
  },
  middleContent: {
    padding: '20px',
  },
  noFound: {
    textAlign: 'center',
  },
})

/* eslint-disable react/prefer-stateless-function */
class MemberFilter extends React.Component {
  constructor(props) {
    super(props)
    const res = props.filterData.length > 0 ? this.createData(props.filterData) : []
    this.state = {
      filteredData: props.filterData.length > 0 ? res[0] : [],
      selected: props.filterData.length > 0 ? res[1] : [],
      open: false,
      expanded: null,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!shallowEqual(nextProps.filterData, this.props.filterData)) {
      const res = this.createData(nextProps.filterData ? nextProps.filterData : [])
      this.setState({ filteredData: res[0], selected: res[1] }, () => {
        this.state.selected.length > 0 && this.props.memberIdSelected(this.state.selected)
      })
    }
    if (nextProps.isOpenOverlay !== this.props.isOpenOverlay) {
      const { open } = this.state
      this.setState({ open: !open })
    }
  }

  createData = (isAllChecked = true) => {
    const recVal = []
    const selectedArr = []
    // eslint-disable-next-line array-callback-return
    filterData[0].value.map(data => {
      let obj = {}
      if (isAllChecked) {
        obj = {
          Id: data.Id,
          Name: data.Name,
          isChecked: true,
        }
        selectedArr.push(data.Id)
      } else {
        obj = {
          Id: data.Id,
          Name: data.Name,
          isChecked: false,
        }
      }
      recVal.push(obj)
    })
    const recArr = [{ key: 'members', value: recVal, key_prefix: '' }]
    return [recArr, selectedArr]
  }

  handleClick = () => {
    const { isOpenCallback } = this.props
    const { open } = this.state
    this.setState({ open: !open })
    isOpenCallback(!open)
  }

  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  handleMembersClick = (event, key) => {
    const { filteredData, selected } = this.state
    const tempFilteredData = [...filteredData]
    tempFilteredData[0].value[key].isChecked = !tempFilteredData[0].value[key].isChecked // prev case
    if (tempFilteredData[0].value[key].isChecked) {
      // push

      if (selected.indexOf(tempFilteredData[0].value[key].Id) === -1) {
        selected.push(tempFilteredData[0].value[key].Id)
      }
    } else {
      // slice
      selected.splice(selected.indexOf(tempFilteredData[0].value[key].Id), 1)
    }
    this.setState({
      filteredData: tempFilteredData,
      selected,
    })
  }

  handleSelectAllClick = () => {
    const { filteredData } = this.state
    const res = this.createData(filteredData)
    this.setState({
      filteredData: res[0],
      selected: res[1],
    })
  }

  handleNoneClick = () => {
    const { filteredData } = this.state
    const res = this.createData(filteredData, false)
    this.setState({
      filteredData: res[0],
      selected: res[1],
    })
  }

  handleChange = () => {
    const { isOpenCallback } = this.props
    const selected = [...this.state.selected]
    this.props.onChange(selected)
    this.setState({ open: false })
    isOpenCallback(false)
  }

  handleCross = () => {
    const { isOpenCallback } = this.props
    this.setState({ open: false })
    isOpenCallback(false)
  }

  render() {
    const { classes } = this.props
    // eslint-disable-next-line no-unused-vars
    // biome-ignore lint/correctness/noUnusedVariables: TODO
    const { filteredData, selected, open, searchText, expanded } = this.state
    return (
      <div autoComplete="on" className={classes.root}>
        {/* biome-ignore lint/complexity/useOptionalChain: TODO */}
        {filteredData &&
          filteredData.map((item, key) => (
            <FormControl
              key={`item${
                // biome-ignore lint/suspicious/noArrayIndexKey: TODO
                key
              }`}
              className={classes.formControl}
            >
              <Select
                value=""
                displayEmpty
                name={item.key}
                readOnly
                className={classes.stgSelect}
                onClick={this.handleClick}
              >
                <MenuItem value="">
                  {selected.length > 0 ? (
                    <span>
                      <span className={classes.countDiv}>{selected.length}</span>
                      <span>
                        {' '}
                        <FormattedMessage {...messages.members} /> <FormattedMessage {...messages.selected} />
                      </span>
                    </span>
                  ) : (
                    <span>
                      <FormattedMessage {...messages.select} /> <FormattedMessage {...messages.members} />
                    </span>
                  )}
                </MenuItem>
              </Select>
              {open && (
                <Grid container className={classes.memberInnerContainer}>
                  <Grid item xs={12} className={classes.topHeading}>
                    <span>
                      <FormattedMessage {...messages.members} />
                    </span>
                    <Icon
                      iconName="cross"
                      color="grey"
                      className={classes.crossIcon}
                      onClick={event => this.handleCross(event)}
                    />
                  </Grid>
                  <Grid item xs={6} className={classes.middleContent}>
                    <span className={classes.countDiv}>{selected.length}</span>
                    <span>
                      {' '}
                      <FormattedMessage {...messages.members} /> <FormattedMessage {...messages.selected} />
                    </span>
                  </Grid>
                  <Grid item xs={6} className={classNames(classes.textAlignRight, classes.middleContent)}>
                    {/** biome-ignore lint/a11y/useKeyWithClickEvents: TODO */}
                    {/** biome-ignore lint/a11y/noStaticElementInteractions: TODO */}
                    <span className={classes.selectAll} onClick={event => this.handleSelectAllClick(event)}>
                      Select All
                    </span>
                    {/** biome-ignore lint/a11y/noStaticElementInteractions: TODO */}
                    {/** biome-ignore lint/a11y/useKeyWithClickEvents: TODO */}
                    <span
                      onClick={event => {
                        this.handleNoneClick(event)
                      }}
                    >
                      None
                    </span>
                  </Grid>
                  <Grid item xs={12}>
                    <div className={classes.venueContainer}>
                      {item.value.length > 0 ? (
                        item.value.map(option => (
                          // biome-ignore lint/correctness/useJsxKeyInIterable: TODO
                          <div className={classes.panel}>
                            <FormControlLabel
                              className={classes.venueLabel}
                              control={
                                <Checkbox
                                  // checked={this.state.checkedB}
                                  onClick={event => {
                                    this.handleMembersClick(event, key)
                                  }}
                                  checked={option.isChecked}
                                  value={option.Id}
                                  color="secondary"
                                />
                              }
                              label={option[`${item.key_prefix}Name`]}
                            />
                          </div>
                        ))
                      ) : (
                        <div className={classes.noFound}>No Data Found</div>
                      )}
                    </div>
                  </Grid>
                  <Grid item xs={12} className={classes.bottomFooter}>
                    <PrimaryButton onClick={this.handleChange}>Done</PrimaryButton>
                  </Grid>
                </Grid>
              )}
            </FormControl>
          ))}
      </div>
    )
  }
}

MemberFilter.defaultProps = {
  onChange: () => {},
  filterData,
  selected: [],
}
export default withStyles(styles)(MemberFilter)
